import React, { useContext, useEffect, useState } from "react";
import "./Project.css";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { makeStyles } from "@mui/styles";
import { motion, useAnimation } from "framer-motion";
import LoaderContext from "../../components/LoaderContext";

const useStyles = makeStyles((theme) => ({
  cardContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexWrap: "wrap",
    maxWidth: "1200px",
    margin: "40px 0",
  },
  card: {
    position: "relative",
    minWidth: "320px",
    height: "440px",
    borderRadius: "15px",
    margin: "30px",
    transition: "0.5s",
  },
  cardBox: {
    backgroundPosition: "center",
    backgroundSize: "cover",
    position: "absolute",
    top: "20px",
    left: "20px",
    right: "20px",
    bottom: "20px",
    bordeRadius: "15px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
    transition: "0.5s",
  },
}));

const Projects = () => {
  const classes = useStyles();
  const controls = useAnimation();
  const { isLoading } = useContext(LoaderContext);
  const [hoveredCard, setHoveredCard] = useState(null);

  useEffect(() => {
    if (!isLoading) {
      controls.start((i) => ({
        opacity: 1,
        y: 0,
        transition: {
          delay: 1.8 + i * 0.1,
        },
      }));
    } else {
      controls.start({ opacity: 0, y: 0 });
    }
  }, [isLoading, controls]);

  return (
    <Container maxWidth="xl" sx={{ marginTop: 10 }}>
      <Box
        sx={{
          alignItems: "center",
          p: 1,
          m: 1,
        }}
      >
        <Grid
          container
          justifyContent="center"
          spacing={1}
          columns={{ xs: 6, sm: 10, md: 12 }}
          sx={{ flexDirection: { xs: "column", md: "row" } }}
        >
          <div className={classes.cardContainer}>
            <motion.div animate={controls} custom={0}>
              <motion.div
                custom={0}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 1.5, duration: 1 }}
                whileHover={{ scale: 1.05, rotateY: 5 }}
                whileTap={{ scale: 0.95 }}
                onHoverStart={() => setHoveredCard(0)}
                onHoverEnd={() => setHoveredCard(null)}
              >
                <div
                  className={`card ${classes.card} ${
                    hoveredCard === 0 ? "card-hovered" : ""
                  }`}
                >
                  <div className="card-box card-box1">
                    <div className="card-content">
                      <motion.h3
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.2 }}
                      >
                        Balance Sheet
                      </motion.h3>
                      <motion.p
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.3 }}
                      >
                        Its a balance-sheet-system app, which is build in React
                        & Firebase
                      </motion.p>
                      <motion.a
                        href="https://react-balance-sheet-891c5.web.app/"
                        whileHover={{ scale: 1.1 }}
                        whileTap={{ scale: 0.9 }}
                      >
                        Live Demo
                      </motion.a>
                    </div>
                  </div>
                </div>
              </motion.div>
            </motion.div>
            <motion.div animate={controls} custom={1}>
              <motion.div
                custom={1}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 2, duration: 1 }}
                whileHover={{ scale: 1.05, rotateY: -5 }}
                whileTap={{ scale: 0.95 }}
                onHoverStart={() => setHoveredCard(1)}
                onHoverEnd={() => setHoveredCard(null)}
              >
                <div
                  className={`card ${classes.card} ${
                    hoveredCard === 1 ? "card-hovered" : ""
                  }`}
                >
                  <div className="card-box card-box2">
                    <div className="card-content">
                      <motion.h3
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.2 }}
                      >
                        Books-Stack
                      </motion.h3>
                      <motion.p
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.3 }}
                      >
                        Its a simple website for books. Which is build with
                        Next.Js , Node.Js & Mongo DB.
                      </motion.p>
                      <motion.a
                        href="https://books-stack-48272.web.app/"
                        whileHover={{ scale: 1.1 }}
                        whileTap={{ scale: 0.9 }}
                      >
                        Live Demo
                      </motion.a>
                    </div>
                  </div>
                </div>
              </motion.div>
            </motion.div>
            <motion.div animate={controls} custom={2}>
              <motion.div
                custom={2}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 2.5, duration: 1 }}
                whileHover={{ scale: 1.05, rotateY: 5 }}
                whileTap={{ scale: 0.95 }}
                onHoverStart={() => setHoveredCard(2)}
                onHoverEnd={() => setHoveredCard(null)}
              >
                <div
                  className={`card ${classes.card} ${
                    hoveredCard === 2 ? "card-hovered" : ""
                  }`}
                >
                  <div className="card-box card-box3">
                    <div className="card-content">
                      <motion.h3
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.2 }}
                      >
                        E-Learning
                      </motion.h3>
                      <motion.p
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.3 }}
                      >
                        Its a product based application, which is build in
                        Next.JS & MongoDB.
                      </motion.p>
                      <motion.a
                        href="https://www.roadtodevelopers.com/"
                        whileHover={{ scale: 1.1 }}
                        whileTap={{ scale: 0.9 }}
                      >
                        Live Demo
                      </motion.a>
                    </div>
                  </div>
                </div>
              </motion.div>
            </motion.div>
          </div>
        </Grid>
      </Box>
    </Container>
  );
};

export default Projects;
